
    export const projectDetails = [
        {
            title : "INFINITY TRAVELS",
            desc : `Infinity Travels is designed to provide a seamless and engaging experience for travelers, combining
    comprehensive information with modern technology to facilitate easy planning and booking of
    travel experiences. The use of advanced web technologies ensures the site is both functional and
    secure, meeting the diverse needs of users`,
            img : "travels.jpg",
            tools : ["VSCODE" , "HTML" , "CSS", "NodeJS" , "ExpressJS" , "PostgreSql" , "Bcrypt"],
            git : "https://github.com/adithya2152/INFINITY-V2",
            type:"webdev",
            video:"/finalinfinity.mp4",
            report:"/infinityreport.pdf"
        },

        {
            title : "CAMPUS CONNECT",
            desc : `CampusConnect is a question and answer platform designed to facilitate com-
    munication and collaboration among students and faculty members within an

    educational institution. The platform allows users to post questions, provide
    answers, and engage in discussions on various topics related to their academic
    interests.`,
            img: "cc.jpg",
            tools : ["VSCODE" , "HTML" , "CSS", "NodeJS" , "ExpressJS" , "PostgreSql" , "Bcrypt"],
            git : "https://github.com/Pranav9347/CampusConnect",
            type:"webdev",
            video:"https://youtu.be/q95e0xQsvlQ",
            report:""
        },
        {
            title: "GYMSYNC",
            desc:`GymSync is a Full Stack Web app which is developed to book slots efficiently `,
            img: "gymsync.png",
            tools: ["VSCODE" , "HTML" , "CSS", "NextJS" , "PWA" , "PostgreSql" , "Supabase" , "Bcrypt"  ],
            git: "https://github.com/adithya2152/Gym_slot_management",
            type:"webdev",
            video:"/gymsync.mp4",
            report:""
        }
    ]

    export const cProjectsDetails = [
        {
            title:"HANGMAN GAME",
            desc: `A Hangman game in C++ is a console-based word-guessing game. The program selects a random word and displays it as underscores. The player guesses letters one at a time. Correct guesses reveal the letter's positions in the word, while incorrect guesses reduce the player's remaining attempts. The game ends when the player guesses the word or runs out of attempts, . This project helps practice loops, conditionals, and string manipulation in C++.`,
            tools: ["VSCODE" , "C++" , "OOPS" , "DATA STRUCTURES" , "ALGORITHMS"],
            img :"hangman.jpg",
            git : "https://github.com/adithya2152/c-c-Projects",
            type:"c",
            video:"",
            report:""
        },

        {
            title:"BANKING MANAGEMENT SYSTEM ", 
            desc:`A Banking Management System in C++ is a console-based application that allows users to create accounts, deposit and withdraw funds, check balances, and view account details. It uses a BankAccount class to manage these operations and employs file handling for data persistence. This system provides a menu-driven interface for easy navigation and input validation.`,
            tools:["VSCODE" , "C++" , "OOPS" , "DATA StRUCTURES" , "ALGORITHMS","FILE HANDELING"],
            img:"bms.jpg",
            git : "https://github.com/adithya2152/c-c-Projects",
            type:"c",
            video:"",
            report:""

        },
        {
            title:"SPORT MANAGEMENT SYSTEM ",
            desc:`This Sports Management System is a console-based application developed in C++ for managing sports-related activities. It provides functionalities to create, update, view, and delete user profiles, register users for events, and display event transactions. The system uses linked lists for managing data in memory and file handling for persistent storage. The user interface is menu-driven, making it easy to navigate through different operations.`,
            tools:["VSCODE" , "C" , "Data Structures" , "Algorithms" , "File Handeling" ],
            img:"sms.jpg",
            git : "https://github.com/adithya2152/c-c-Projects",
            type:"c",
            video:"",
            report:""

        },

        {
            title:"LIBRARY MANAGEMENT SYSTEM ",
            desc:`A Library Management System in C++ is a console-based application that manages library operations. It allows users to add books, issue books to members, return books, and view book details. The system uses a Book class for book management and file handling for data persistence. It provides a menu-driven interface for easy navigation and input validation.`,
            tools:["VSCODE" , "C" , "Data Structures" , "Algorithms" , "File Handeling" ],
            img:"lms.jpg",
            git : "https://github.com/adithya2152/c-c-Projects",
            type:"c",
            video:"",
            report:""

        },

    ]
